import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";

export class editActionButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    handleOpenEdit = () => {
        console.log("open edit");
        this.props.agGridReact.props.editVehicleData(this.props.data)
    };

    render() {
        return (
            <>
                <Button
                    onClick={this.handleOpenEdit}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <Icon name="edit" color="green" />
                </Button>
            </>
        );
    }
}

export default editActionButton;
